/* eslint-disable prettier/prettier */
import request from '@/utils/request'

// 获取供应商认定申请基本信息
export function supplierApplyBase(applyCode) {
    return request({
        url: `/api/srm-slcm/suppDomainQualifyApply/getInfoByApplyCode/${applyCode}`,
        method: 'get'
    })
}

// 获取评审项模版信息
export function supplierApplyInfo(obj) {
    return request({
        url: '/api/srm-slcm/suppIntroduceReviewTemplate/getSuppDomainApplyTemplate',
        method: 'get',
        params: obj
    })
}

// 评审结果上报接口
export function saveReviewResult(obj) {
    return request({
        url: '/api/srm-slcm/suppDomainQualifyApply/handleReview',
        method: 'post',
        data: obj
    })
}
